module.exports = __webpack_public_path__ + "static/media/ic_text.337b0851.svg";